export default "__VITE_ASSET__BjEVYgA4__"